import DropMenu from './dropdown-menu';
import Sidebar from "./sidebar";

const Menus = {
    DropMenu,
    Sidebar
};

export default Menus;